
interface AreaCTAProps {
  area: string;
}

export default function AreaCTA({ area }: AreaCTAProps) {
  return (
    <section className="py-20 px-6 bg-gradient-to-br from-sky-500 to-sky-600">
      <div className="max-w-4xl mx-auto text-center text-white">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Ready to Transform Your {area} Property?
        </h2>
        <p className="text-xl mb-8 leading-relaxed">
          Get a free, no-obligation quote for your painting and decorating project in {area}. 
          Our experienced team is ready to bring your vision to life with professional service 
          and exceptional results.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/booking"
            className="inline-block px-8 py-4 bg-white text-sky-600 font-bold rounded-lg hover:bg-gray-50 transition-colors duration-300 whitespace-nowrap"
          >
            Get Free Quote
          </a>
          <a
            href="tel:07595037441"
            className="inline-block px-8 py-4 bg-gray-800 text-white font-bold rounded-lg hover:bg-gray-700 transition-colors duration-300 whitespace-nowrap"
          >
            Call: 07595037441
          </a>
        </div>
        <p className="mt-8 text-sm">
          Serving {area} and surrounding areas with professional painting services
        </p>
      </div>
    </section>
  );
}
